import { createAsyncActionType } from './index';

export const APPROVAL_REQUESTS_GET = createAsyncActionType(
  'eventApproval',
  'APPROVAL_REQUESTS_GET'
);

export const APPROVAL_STATUS_SET = createAsyncActionType(
  'eventApproval',
  'APPROVAL_STATUS_SET'
);
